import { parameterPattern } from '_/constants/common';

import * as nameValidator from './validation/nameValidator';
import * as slugValidator from './validation/slugValidator';

const avroSchemaPattern = /^[a-zA-Z]([a-zA-Z0-9]|_[a-zA-Z0-9])*$/;
const extractorIdPattern = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

/**
 * @deprecated use utils/validation/slugValidator directly
 */
export function validateSlug(slug) {
  console.warn('Use `utils/validation/slugValidator` directly');
  return slugValidator.validateSlug(slug);
}

export function validateParameter(parameter) {
  return parameterPattern.test(parameter);
}

/**
 * @deprecated use utils/validation/nameValidator
 */
export function checkIfNameExists(listOfExistingItems = [], newName = '') {
  console.warn('Use `utils/validation/nameValidator`');
  return nameValidator.checkIfNameExists(listOfExistingItems, newName);
}

/**
 * @deprecated use utils/validation/slugValidator directly
 */
export function checkIfSlugExists(listOfExistingItems, newSlug) {
  console.warn('Use `utils/validation/slugValidator` directly');
  return slugValidator.checkIfSlugExists(listOfExistingItems, newSlug);
}

export function checkIfNameAndEnvironmentExists(
  listOfExistingItems: { name: string; environment?: string }[] = [],
  newName = '',
  environment = '',
) {
  return !!listOfExistingItems.find(
    (item) => item.name.toLowerCase() === newName.toLowerCase() && item.environment === environment,
  );
}

export const filterErrorsForField = (errors, fieldName) =>
  errors.filter(({ type }) => type === fieldName).map(({ error }) => error);

export function validateAvroSchema(avroSchema) {
  return avroSchemaPattern.test(avroSchema);
}

export function validateExtractorId(extractorId) {
  return extractorIdPattern.test(extractorId);
}

export function validateIso3Country(iso3Country) {
  return /^[A-Z]{3}$/.test(iso3Country);
}

export function checkNumberValue(value) {
  return value || value === 0;
}

export function checkPositiveNumber(value) {
  return checkNumberValue(value) && value >= 0;
}

export function checkPositiveNumberWithMinMaxValue(value, min = 0.1, max = 999.99) {
  return checkNumberValue(value) && value >= min && value <= max;
}

export function checkIfDomainExists(existingItems: { domain: string }[] = [], domain: string) {
  return !!existingItems.find((item) => item.domain === domain);
}
